module.exports = __webpack_public_path__ + "img/lampada-circle.226901c6.png";